export default {
	id: null,
	role: null,
	name: null,
	email: null,
	emailVerified: false,
	locale: null,
	organizationId: null,
};
